import React from 'react';
import { UserUnitPriceInput, Tooltip } from 'components/common';
import DataSourcePriceInput from './DataSourcePriceInput';

const PriceFormField = ({ config, currency, value, values, setValue, register, errors, disabled, readOnly, setFetchInProgress, precision, dataSourcesEnabled, userUnitPriceId }) => {

  const getLabel = () => {
    if(config.label_eval != undefined) {
      return eval(config.label_eval)
    }
    return t(config.label)
  }

  const dataSourceConfigKey = `${config.name}_data_source_config`;
  const dataSourceConfig = values[dataSourceConfigKey];

  const handleDataSourceConfigChange = (newConfig) => {
    setValue(dataSourceConfigKey, newConfig);
  };

  return (
    <tr>
      <td>
        {getLabel()} { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <UserUnitPriceInput
          name={config.name}
          placeholder={config.placeholder ? t(config.placeholder) : undefined}
          register={register}
          errors={errors}
          value={value}
          class_name={config.class_name}
          validators={config.validators != undefined ? config.validators : []}
          currency={currency}
          precision={precision}
          onChange={(e) => setValue(config.name, e.target.value)}
          readOnly={readOnly || (dataSourceConfig && dataSourceConfig.data_source_id)}
        />
        {dataSourcesEnabled && config.data_source_enabled !== false && !readOnly && (
          <DataSourcePriceInput
            value={value}
            onChange={(e) => setValue(config.name, e.target.value)}
            currency={currency}
            precision={precision}
            dataSourceConfig={dataSourceConfig}
            onDataSourceConfigChange={handleDataSourceConfigChange}
            disabled={disabled}
            userUnitPriceId={userUnitPriceId}
            attributeName={config.name}
          />
        )}
      </td>
    </tr>
  )
}

export default PriceFormField;
